import axios from 'axios'
import env from '../env'
import { storeMobx, dealCheckMaterialData } from 'restaurant'

export default class OrderAPI {
  static async save (data: any, isMember: boolean = false) {
    let url = isMember && !data.infos.ordersId ? `${env.MEMBER}/order` : env.ORDERJMOBILE
    // 后付费
    if (data.infos.payMode) {
      url += '/commitCart'
    } else {
      url += data.infos.ordersId ? '/updateAllDetail' : '/save'
    }

    // 新版供应链校验货品库存
    if (storeMobx.info.isNewSupply) {
      const productInventoryList = dealCheckMaterialData(data)
      const checkRes: any = await this.checkMaterialStock({ productInventoryList }).catch(() => ({
        result: {
          stockSufficient: 1
        }
      }))
      if (checkRes?.result?.stockSufficient === 0) {
        const _data = checkRes.result?.data?.filter((item: any) => item.cnt >= 0)
          .map((item: any) => {
            const _product: any = productInventoryList.find((p: any) => `${p.productNo}${p.scaleNo}` === `${item.productNo}${item.scaleNo}`) || {}
            return {
              ...item,
              ..._product,
              cnt: item.cnt
            }
          })
        const error = {
          code: 'supply-stock-insufficient',
          data: _data
        }
        throw error
      }
    }

    return axios.post(url, data).then((res: any) => {
      if (res.success) {
        throw res
      }
      return res
    })
  }

  static update (data: any) {
    const saveData = Object.assign({
      bo,
      storeId: storeMobx.info.storeId,
      brandId: storeMobx.info.brandId
    }, data)
    return axios.post(env.ORDERJMOBILE + '/update', saveData).then((res: any) => {
      if (res.success) {
        throw res
      }
      return res
    })
  }

  /**
   * 订单列表
   * @param searchData 筛选数据
   * @param isCanCallMeal 是否支持发餐叫号
   * @returns
   */
  static list (searchData: any, isCanCallMeal?: boolean) {
    const data = Object.assign({
    }, searchData)
    return axios.post(env.ORDERJMOBILE + '/getOrdersListByStore', data).then((res: any) => {
      if (res?.result?.content) {
        return res
      } else {
        throw res
      }
    })
  }

  static memberlist (searchData: any) {
    const data = Object.assign({
    }, searchData)
    return axios.post(env.ORDERMEMBER + '/getOrdersListByMember', data)
  }

  static getOrdersListByMemberWithToday (searchData: any, option?: any) {
    const data = Object.assign({
    }, searchData)
    return axios.post(env.ORDERMEMBER + '/getOrdersListByMemberWithToday', data, option)
  }

  static orderlist (searchData: any) {
    const data = Object.assign({
      brandId: storeMobx.info.brandId
    }, searchData)
    return axios.post(env.MEMBER + '/order/list', data)
  }

  static memberNeedTablelist (searchData: any) {
    const data = Object.assign({
      brandId: storeMobx.info.brandId,
      storeId: storeMobx.info.storeId,
      showExt: 1,
    }, searchData)
    return axios.post(env.ORDERJMOBILE + '/getNeedCreateTableListByMember', data)
  }

  static get (ordersId: string, moreInfo: {
    member: boolean;
    isNoToken?: boolean;
    deliveryAndInvoice?: boolean;
    showOrderCart?: boolean;
    fromGoldPlan?: boolean;
    brandId?: number;
    showPic?: number;
    showMember?: 0 | 1;
    showPingtanByMember?: 0 | 1;
  }) {
    // let url: string = `${env.MEMBER}/order/details`
    // if (!Config.token) {
    //   url = `${env.ORDERJMOBILE}/getOrdersDetail`
    // }
    let url = `${env.ORDERJMOBILE}/getOrdersDetail`
    if (moreInfo?.fromGoldPlan) {
      url = `${env.MEMBER}/order/noTokenDetails`
    }
    // if (moreInfo?.showPingtanByMember) {
    //   url = `${env.ORDERJMOBILE}/getOrdersDetail`
    // }
    const params = {
      ordersId,
      showMember: moreInfo?.showMember || moreInfo?.member ? 1 : 0,
      // showDeliverInfo: moreInfo?.deliveryAndInvoice ? 1 : 0,
      showDeliverInfo: 1,
      showOrderCart: moreInfo?.showOrderCart ? 1 : 0,
      showTaxDetail: 1,
      showKds: 1,
      showPic: 1,
      showPingtanByMember: moreInfo?.showPingtanByMember || 0,
      showUseCoupons: 1,
      showMktProducts: 1,
    } as any
    moreInfo?.brandId && (params.brandId = moreInfo.brandId)
    return axios.post(url, params)
  }

  static refund (searchData: any) {
    const url: string = `${env.ORDERMEMBER}/refund`
    const data = searchData
    return axios.post(url, data)
  }

  static statistics (searchData: any) {
    return axios.post(env.ORDER + '/query/getTotalSum', searchData)
  }

  static isNiceGuy (eatType) {
    return axios.post(env.ORDERMEMBER + '/isNiceGuy', { eatType })
  }

  static cancel (data: any) {
    const saveData = Object.assign({
      storeId: storeMobx.info.storeId,
      brandId: storeMobx.info.brandId,
      bo
      // deviceId: storeInfo.deviceId
    }, data)
    return axios.post(env.ORDER + '/cancelOrdersByBuyer', saveData, { retry: 3 } as any).then((res: any) => {
      if (res.error) {
        throw res
      }
      return res
    })
  }

  static reduce (data: any) {
    return Promise.reject('no support')
  }

  static rejectOrders (data: any) {
    return Promise.reject('no support')
  }

  static reSave (data: any) {
    return Promise.reject('no support')
  }

  static splitProduct (ordersId: string, details: {
    [detailId: string]: number[];
  }) {
    return Promise.reject('no support')
  }

  static calMktFee (data: any) {
    const saveData = Object.assign({
      storeId: storeMobx.info.storeId,
      brandId: storeMobx.info.brandId,
      bo
    }, data)
    return axios.post(env.ORDER + '/calMktFee', saveData)
  }

  static sendMsg (orderId: string, value: string, type: 'mobile' | 'email') {
    return axios.post(`${env.JMOBILE}/mailServer/${type === 'mobile' ? 'sendSms' : 'sendMail'}`, {
      mobile: type === 'mobile' ? value : undefined,
      toMail: type === 'email' ? value : undefined,
      templateCode: 'successOrder',
      orderId,
      storeId: storeMobx.info.storeId || 0,
      brandId: storeMobx.info.brandId,
    })
  }

  static startPay (data: {
    addUserId?: string;
    addUserName?: string;
    ordersId: string;
    paidFee: number;
    clientNumber: string;
    storeId?: number;
  }) {
    let url = `${env.ORDER}/startPay`
    return axios.post(url, Object.assign({
      storeId: storeMobx.info.storeId || 0,
      brandId: storeMobx.info.brandId || Config.BRANDID || 0
    }, data))
  }

  /** 更新订单的餐品详情的履行时间 */
  static updateDetailStartTime (startTimes: { [detailId: string]: string }, ordersId: string) {
    return Promise.reject(false)
  }

  /** 将当前的订单状态直接变成支付成功的状态 */
  static thirdPay (ordersId: string) {
    return Promise.reject(false)
  }

  static clearNotAcceptedDetail (ordersId: string) {
    return axios.post(env.ORDERJMOBILE + '/clearNotAcceptedDetail', {
      ordersId,
      storeId: storeMobx.info.storeId || 0,
      brandId: storeMobx.info.brandId
    }).then((res: any) => {
      if (res.success) {
        throw res
      }
      return res
    })
  }

  /** 获取手机退款配置 */
  static getMobileRefundPlan = async () => {
    const url: string = `${env.JMOBILE}/mobileRefund/getMobileRefundPlan`
    return await axios.post(url).catch((err) => {
      return err
    })
  }

  /** 获取手机退款申请 */
  static applyMobileRefund = async (params: {
    ordersId: string;
    storeId: number;
    refundReason: string;
    message?: string;
  }) => {
    const url: string = `${env.ORDERMEMBER}/applyRefund`
    return await axios.post(url, params).catch((err) => {
      return err
    })
  }

  static delCart (ordersId: string) {
    return axios.post(env.ORDERJMOBILE + '/delCart', {
      ordersId,
      storeId: storeMobx.info.storeId || 0,
      brandId: storeMobx.info.brandId
    }).then((res: any) => {
      if (res.success) {
        throw res
      }
      return res
    })
  }

  static batchOrdersPay (orders: any[]) {
    return axios.post(`${env.ORDERJMOBILE}/ordersBatchPay`, {
      payList: orders
    }).then((res: any) => {
      if (res.success) {
        throw res
      }
      return res
    })
  }

  static updateTable (info: any) {
    return Promise.resolve({})
  }

  static createTable (info: any) {
    return axios.post(`${env.ORDERJMOBILE}/createTable`, info).then((res: any) => {
      if (res.success) {
        throw res
      }
      return res
    })
  }

  static updatePrePayPrintTime (ordersId: string) {
    return Promise.resolve({})
  }

  static rePrint (ordersId: string, ticketType: string, extInfo?: { paymentId: number }) {
    return Promise.resolve({})
  }
  static callRider (params: { ordersId: string; storeId: number; facanStauts?: IOutOrderStatus }) {
    return Promise.resolve(false)
  }

  static async checkConsumeSendCoupon (params: { ordersId: string; storeId: number }) {
    const Url: string = `${env.MEMBER}/memberCoupon/checkConsumeSendCoupon`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  static postChangeTableWithOrders (info: any) {
    return Promise.resolve({})
  }
  static updateExpress (info: any) {
    return Promise.resolve({})
  }

  /** 检查供应链库存 */
  static async checkMaterialStock (data: any) {
    const url = `${env.JMOBILE}/jmobile/checkMaterialStock`
    return await axios.post(url, Object.assign({
      brandId: storeMobx.info.brandId,
      storeId: storeMobx.info.storeId,
    }, data))
  }
}
